// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"LoaderOverlay_spinnerContainer__4r+dC","spinner":"LoaderOverlay_spinner__ZjXBc"};